var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'is-md': _vm.isMd() },attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('keep-alive',[_c('router-view',{key:`page-${_vm.$route.path}`})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }